import React from 'react';
import PropTypes from 'prop-types';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from './styles';

export function EditButton({
  content, onClick, disabled, title,
}) {
  return (
    <CPButton
      onClick={onClick}
      disabled={disabled}
      content={content}
      icon={faEdit}
      title={title}
    />
  );
}

EditButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

EditButton.defaultProps = {
  onClick: () => null,
  content: 'Редагувати',
  disabled: false,
  title: 'Редагувати',
};

export default EditButton;
